import { render, staticRenderFns } from "./ImageDom.vue?vue&type=template&id=42bf5d2e&scoped=true&"
import script from "./ImageDom.vue?vue&type=script&lang=js&"
export * from "./ImageDom.vue?vue&type=script&lang=js&"
import style0 from "./ImageDom.vue?vue&type=style&index=0&id=42bf5d2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf5d2e",
  null
  
)

export default component.exports